import React, { useState } from 'react';
import { HomeIcon, UsersIcon, MessageSquareTextIcon, SettingsIcon, MenuIcon, XIcon } from 'lucide-react';
interface NavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
export const Navigation: React.FC<NavigationProps> = ({
  activeTab,
  setActiveTab
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const tabs = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: <HomeIcon size={18} data-id="element-549" />
  }, {
    id: 'people',
    label: 'People',
    icon: <UsersIcon size={18} data-id="element-550" />
  }, {
    id: 'messages',
    label: 'Messages',
    icon: <MessageSquareTextIcon size={18} data-id="element-551" />
  }, {
    id: 'settings',
    label: 'Settings',
    icon: <SettingsIcon size={18} data-id="element-552" />
  }];
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    setMobileMenuOpen(false);
  };
  return <div className="bg-white border-b border-gray-200" data-id="element-553">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-554">
        <div className="flex justify-between h-16" data-id="element-555">
          {/* Logo */}
          <div className="flex" data-id="element-556">
            <div className="flex-shrink-0 flex items-center" data-id="element-557">
              <span className="text-xl font-bold text-gray-900" data-id="element-558">
                <span className="text-[#f9b30f]" data-id="element-559">LinkedIn</span> Intent Monitor
              </span>
            </div>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex md:ml-6 md:items-center" data-id="element-560">
            <div className="flex space-x-1" data-id="element-561">
              {tabs.map(tab => <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`inline-flex items-center px-3 py-2 border-b-2 text-sm font-medium ${activeTab === tab.id ? 'border-[#f9b30f] text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-562">
                  <span className="mr-2" data-id="element-563">{tab.icon}</span>
                  {tab.label}
                </button>)}
            </div>
            <div className="ml-6" data-id="element-564">
              <button className="bg-[#f9b30f] hover:bg-[#e0a40e] text-white px-4 py-2 rounded-md text-sm font-medium" data-id="element-565">
                + New Monitor
              </button>
            </div>
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-566">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none" data-id="element-567">
              {mobileMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-568" /> : <MenuIcon className="block h-6 w-6" data-id="element-569" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      <div className={`md:hidden ${mobileMenuOpen ? 'block' : 'hidden'}`} data-id="element-570">
        <div className="pt-2 pb-3 space-y-1" data-id="element-571">
          {tabs.map(tab => <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`block w-full text-left px-3 py-2 text-base font-medium ${activeTab === tab.id ? 'text-[#f9b30f] bg-gray-50 border-l-4 border-[#f9b30f]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-572">
              <div className="flex items-center" data-id="element-573">
                <span className="mr-3" data-id="element-574">{tab.icon}</span>
                {tab.label}
              </div>
            </button>)}
          <div className="px-3 py-3" data-id="element-575">
            <button className="w-full bg-[#f9b30f] hover:bg-[#e0a40e] text-white px-4 py-2 rounded-md text-sm font-medium" data-id="element-576">
              + New Monitor
            </button>
          </div>
        </div>
      </div>
    </div>;
};